import { makeAutoObservable } from 'mobx';
import URI from 'urijs';

export default class BlockScanningStore {
  userStore;
  // Store blocks and reports for specific property.
  propertyBlocks = [];
  propertyReports = [];
  // Store blocks and reports for all user's properties.
  userBlocks = []; // [{ property_id: number, block_clusters: object[] }, ...]
  userReports = []; // [{ property_id: number, reports: object[], total_reports: number }, ...]

  constructor(userStore) {
    this.userStore = userStore;
    makeAutoObservable(this);
  }

  async fetchUserBlocks(pageSize, offset) {
    try {
      const selectedDatabase = this.userStore.selectedDatabase;
      const bearerToken = this.userStore.bearerToken;
      const url = new URI(
        `${process.env.REACT_APP_PROPERTIES_API_URL}api/fruition/blocks/properties`
      );
      url
        .addQuery('page_size', pageSize)
        .addQuery('offset', offset)
        .addQuery('without[]', 'primaryGaBlock.metadata')
        .addQuery('without[]', 'property');
      const response = await fetch(url.valueOf(), {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          SeasonalDatabase: selectedDatabase
        }
      });
      // Handle bad response.
      if (!response.ok) {
        if (response.status === 401) this.userStore.refresh();
        return;
      }
      // Parse data.
      const responseData = await response.json();
      this.userBlocks = [...this.userBlocks, ...responseData.data];
      return responseData;
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error(err);
    }
  }

  async fetchUserReports(pageSize, offset) {
    try {
      const season = this.userStore.selectedDatabase.split('_')[1];
      const period = 7; // 1 week.
      const selectedDatabase = this.userStore.selectedDatabase;
      const bearerToken = this.userStore.bearerToken;
      const url = new URI(
        `${process.env.REACT_APP_PROPERTIES_API_URL}api/fruition/crop-scanning/reports/properties/latest`
      );
      url
        .addQuery('page_size', pageSize)
        .addQuery('offset', offset)
        .addQuery('season', season)
        .addQuery('period', period);
      const response = await fetch(url.valueOf(), {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          SeasonalDatabase: selectedDatabase
        }
      });
      // Handle bad response.
      if (!response.ok) {
        if (response.status === 401) this.userStore.refresh();
        return;
      }
      // Parse data.
      const responseData = await response.json();
      this.userReports = [...this.userReports, ...(responseData?.data || [])];
      return responseData;
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error(err);
    }
  }
}

